import React from 'react';
import styled from 'styled-components';
import Jumbotron from 'react-bootstrap/Jumbotron'
import Container from 'react-bootstrap/Container'
const Styles = styled.div`
    .container{
      display: flex;
  align-items: center;
  justify-content: center;
    }
`;
export const NoMatch = () => (
  <Styles>
    <Jumbotron fluid>
      <Container >
        <h1>No Match 404</h1>
      </Container>
    </Jumbotron>
  </Styles >


)